// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorMessage_errorMessage__zqnzX","offscreen":"errorMessage_offscreen__73hG3"};